export const SYMBOL_GROUPS_FETCH = 'SYMBOL_GROUPS_FETCH';
export const SYMBOL_GROUPS_IS_FETCHING = 'SYMBOL_GROUPS_IS_FETCHING';
export const SYMBOL_GROUPS_API = 'symbolgroups';
export const SYMBOL_GROUP_EDIT = 'SYMBOL_GROUP_EDIT';
export const SYMBOL_GROUP_SAVE = 'SYMBOL_GROUP_SAVE';
export const SYMBOL_GROUP_FILTER = 'SYMBOL_GROUP_FILTER';


// WEBPACK FOOTER //
// ./src/constants/symbolGroups.js